import { render, staticRenderFns } from "./BaseScreenCard.vue?vue&type=template&id=df86b606&scoped=true&"
import script from "./BaseScreenCard.vue?vue&type=script&lang=js&"
export * from "./BaseScreenCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseScreenCard.vue?vue&type=style&index=0&id=df86b606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df86b606",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VChip,VIcon})
